<template>
  <div class="hidden-input">
    <input type="hidden"
      :id="options.name"
      :value="value"
      :name="options.name"/>
  </div>
</template>

<script>
export default {
  name: 'HiddenInput',
  props: {
    value: {
      type: null
    },
    options: {
      type: Object,
      default () {
        return {
          value: '',
          valid: false,
          dirty: false
        }
      }
    }
  },
  data () {
    return {
      isValid: true
    }
  },
  methods: {
    validate (val = this.value) {
      this.isValid = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/HiddenInput.vue